<template>
    <section class="section section-result bg-primary-color-light">
        <div class="container">
            <div class="content">
                <p class="h3">Kosten im Monat und Jahr</p>
                <h2>Sprit-/Stromverbrauch</h2>
                <div class="result-wrapper">
                    <div class="columns row-border-right is-vcentered">
                        <div class="column is-two-thirds has-padding-right">
                            <table class="table is-fullwidth">
                                <tr>
                                    <th></th>
                                    <th class="has-text-right">Monat / €</th>
                                    <th class="has-text-right">Jahr / €</th>
                                </tr>
                                <tr>
                                    <td>Konventionelles Auto<sup>2</sup></td>
                                    <td class="has-text-right">{{ costs.month.conventional }} €</td>
                                    <td class="has-text-right">{{ costs.year.conventional }} €</td>
                                </tr>
                                <tr>
                                    <td>Elektroauto<sup>3</sup></td>
                                    <td class="has-text-right">{{ costs.month.electric }} €</td>
                                    <td class="has-text-right">{{ costs.year.electric }} €</td>
                                </tr>
                                <tr v-if="savesMoney">
                                    <td class="primary-color">Sie sparen</td>
                                    <td class="primary-color has-text-right">{{ costs.month.economy  }} €</td>
                                    <td class="primary-color has-text-right">{{ costs.year.economy }} €</td>
                                </tr>
                                <tr v-else>
                                    <td class="">Sie sparen</td>
                                    <td class="has-text-right">{{ costs.month.economy  }} €</td>
                                    <td class="has-text-right">{{ costs.year.economy }} €</td>
                                </tr>
                            </table>
                        </div>
                        <div class="column result-bg has-text-centered">
                          <span>{{ co2 }}</span><br />Kg CO<sub>2</sub> pro Jahr
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  export default {
    name: "Result",
    data () {
      return {
        savesMoney: false,
        co2: 0,
        costs: {
          year: {
            conventional: 0,
            electric: 0,
            economy: 0,
          },
          month: {
            conventional: 0,
            electric: 0,
            economy: 0,
          }
        },
      }
    },
    mounted () {
      this.getCosts();
    },
    methods: {
      getCosts() {
          this.$root.$on('calculate', data => {
              // this.costs = data;
              const monthConventional = data.conventional / 12;
              const monthElectric = data.electric / 12;

              const economyYear = data.conventional - data.electric;
              const economyMonth = monthConventional - monthElectric;

              this.co2 = data.co2;

              this.savesMoney = economyMonth >= 0;

              this.costs.year.conventional = data.conventional.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
              this.costs.year.electric = data.electric.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
              this.costs.year.economy = economyYear.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");

              this.costs.month.conventional = monthConventional.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
              this.costs.month.electric = monthElectric.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
              this.costs.month.economy = economyMonth.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");

          })
      }
    },

  }
</script>

<style lang="scss" scoped>

</style>